(function ($, Drupal) {
  Drupal.behaviors.home = {
    attach: function (context, settings) {
      const prevBtn = document.querySelector('.views_slideshow_controls_text_previous a');
      if (prevBtn) {
        prevBtn.innerHTML = '';
      }

      const nextBtn = document.querySelector('.views_slideshow_controls_text_next a');
      if (nextBtn) {
        nextBtn.innerHTML = '';
      }

      var viewFrontPage = context.querySelector('.view-frontpage');
      if (viewFrontPage) {
        $('.view-frontpage .view-content', context).bxSlider({
          mode: 'horizontal',
          infiniteLoop: true,
          adaptiveHeight: true,
          pager: true,
          auto: true,
          pause: 6000,
          speed: 1500,
          autoDelay: 5000,
          preventDefaultSwipeX: false,
          maxSlides: 6,
          minSlides: 2,
          slideMargin: 1,
          nextText: '',
          prevText: '',
          touchEnabled: false,
          onSlideBefore: function ($slideElement, oldIndex, newIndex) {
            $('.view-frontpage .view-content .dots a').removeClass('active');
            $('.view-frontpage .view-content .dots').find('a:eq(' + newIndex + ')').addClass('active');
          },
          onSliderLoad: function (currentIndex) {
            var pager = $('.view-frontpage .bx-pager.bx-default-pager');
            $('.view-frontpage .view-content .dots').append(pager);
          }
        }).css('visibility', 'visible').hide().fadeIn();
      }

      var viewFeaturedContent = context.querySelector('.field--name-field-featured-content');
      if (viewFeaturedContent) {
        $('.field--name-field-featured-content').bxSlider({
          mode: 'horizontal',
          infiniteLoop: true,
          adaptiveHeight: true,
          pager: false,
          auto: true,
          pause: 4000,
          preventDefaultSwipeX: false,
          maxSlides: 6,
          minSlides: 2,
          slideMargin: 10,
          nextText: '',
          prevText: '',
          touchEnabled: false,
          onSliderLoad: function (currentIndex) {
            var controls = $('#block-ensadestacadoshome .bx-controls');
            $('.field--name-field-featured-content .dots').append(controls);
          }
        });
      }

      var divs = context.querySelectorAll('.view-display-id-block_view_prensa_teaser_short .prensa-teaser-short__row');
      if (divs && divs.length > 0) {
        $(context).find('.view-display-id-block_view_prensa_teaser_short').once('groupRows').each(function () {
          var prensaTeaserShortRows = $('.view-display-id-block_view_prensa_teaser_short .prensa-teaser-short__row');
          for(var i = 0; i < prensaTeaserShortRows.length; i+=3) {
            prensaTeaserShortRows.slice(i, i+3).wrapAll("<div class='prensa-teaser-row-wrapper'></div>");
          }
        });
      }

      var viewPrensaTeaserShort = context.querySelector('.block-views-blockview-prensa-teaser-block-view-prensa-teaser-short .view-content');
      if (viewPrensaTeaserShort) {
        $('.block-views-blockview-prensa-teaser-block-view-prensa-teaser-short .view-content', context).bxSlider({
          mode: 'horizontal',
          infiniteLoop: true,
          pager: true,
          auto: true,
          moveSlides: 1,
          pause: 4000,
          controls: false,
          preventDefaultSwipeX: false,
          maxSlides: 3,
          minSlides: 1,
          touchEnabled: false,
          onSlideBefore: function ($slideElement, oldIndex, newIndex) {
            $('.block-views-blockview-prensa-teaser-block-view-prensa-teaser-short .dots a').removeClass('active');
            $('.block-views-blockview-prensa-teaser-block-view-prensa-teaser-short .dots').find('a:eq(' + newIndex + ')').addClass('active');
          },
          onSliderLoad: function (currentIndex) {
            var pagerPrensa = $('.block-views-blockview-prensa-teaser-block-view-prensa-teaser-short .bx-pager.bx-default-pager');
            $('.block-views-blockview-prensa-teaser-block-view-prensa-teaser-short .dots').append(pagerPrensa);
          }
        }).css('visibility', 'visible').hide().fadeIn();
      }

      var viewFeaturedClients = context.querySelector('.block-featured-clients');
      if (viewFeaturedClients) {
        $('.block-featured-clients .view-content').bxSlider({
          mode: 'horizontal',
          auto: true,
          moveSlides: 1,
          pause: 2000,
          infiniteLoop: true,
          pager: false,
          slideWidth: 205,
          preventDefaultSwipeX: false,
          controls: false,
          maxSlides: 6,
          minSlides: 1,
          slideMargin: 10
        });
      }
    }
  };
})(jQuery, Drupal);
